var _rect, _rect2, _path, _path2, _path3, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _path4, _path5, _path6, _path7, _path8, _g, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _path9, _path0, _path1, _path10, _path11, _path12, _g2, _path13, _g3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgMessage3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 121,
    viewBox: "0 0 137 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.6279,
    y: 98.2085,
    width: 85.6177,
    height: 5.03634,
    rx: 0.464892,
    fill: "#D0D1D2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22.6631,
    y: 95.6904,
    width: 75.545,
    height: 2.51816,
    rx: 0.464892,
    fill: "#E4E5E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1816 41.2203C25.1816 40.7068 25.5979 40.2905 26.1114 40.2905H94.7605C95.274 40.2905 95.6903 40.7068 95.6903 41.2203V95.6902H25.1816V41.2203Z",
    fill: "#ABADAF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8086 36.1842C42.8086 35.6707 43.2249 35.2544 43.7384 35.2544H77.1331C77.6466 35.2544 78.0629 35.6707 78.0629 36.1842V95.6904H42.8086V36.1842Z",
    fill: "#D0D1D2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0167 22.6636C61.0167 22.3426 60.7565 22.0824 60.4355 22.0824C60.1146 22.0824 59.8544 22.3426 59.8544 22.6636H61.0167ZM61.0167 35.2544V22.6636H59.8544V35.2544H61.0167Z",
    fill: "#ABADAF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 61.6943,
    y: 22.6636,
    width: 2.51817,
    height: 7.5545,
    fill: "#FF4F00"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 64.2129,
    y: 22.6636,
    width: 5.03633,
    height: 7.5545,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 69.249,
    y: 22.6636,
    width: 2.51817,
    height: 7.5545,
    fill: "#F4440B"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 30.2178,
    y: 47.8452,
    width: 7.5545,
    height: 7.5545,
    fill: "#F8F9F9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 83.0996,
    y: 47.8452,
    width: 7.5545,
    height: 7.5545,
    fill: "#F8F9F9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 50.3633,
    y: 47.8452,
    width: 7.5545,
    height: 7.5545,
    fill: "#F8F9F9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 62.9541,
    y: 47.8452,
    width: 7.5545,
    height: 7.5545,
    fill: "#F8F9F9"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 30.2178,
    y: 60.436,
    width: 7.5545,
    height: 7.5545,
    fill: "#F8F9F9"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 83.0996,
    y: 60.436,
    width: 7.5545,
    height: 7.5545,
    fill: "#F8F9F9"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 50.3633,
    y: 60.436,
    width: 7.5545,
    height: 7.5545,
    fill: "#F8F9F9"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 62.9541,
    y: 60.436,
    width: 7.5545,
    height: 7.5545,
    fill: "#F8F9F9"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 30.2178,
    y: 73.0269,
    width: 7.5545,
    height: 7.5545,
    fill: "#F8F9F9"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 83.0996,
    y: 73.0269,
    width: 7.5545,
    height: 7.5545,
    fill: "#F8F9F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3633 73.9566C50.3633 73.4431 50.7796 73.0269 51.2931 73.0269H69.5788C70.0923 73.0269 70.5086 73.4431 70.5086 73.9566V95.6904H50.3633V73.9566Z",
    fill: "#F8F9F9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4355 95.6904V73.0269",
    stroke: "#E4E5E5",
    strokeWidth: 1.16223
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.7577 6.43359C88.2667 6.43359 87.8672 6.86248 87.8672 7.38671L87.8672 43.2284C87.8672 43.9355 88.4404 44.5088 89.1475 44.5088L102.532 44.5088H115.75C116.457 44.5088 117.03 43.9355 117.03 43.2284L117.03 7.38681C117.03 6.86258 116.631 6.43369 116.14 6.43369H115.072L88.7577 6.43359Z",
    fill: "#E4E5E5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.4198 9.09619C90.9288 9.09619 90.5293 9.52508 90.5293 10.0493L90.5293 45.891C90.5293 46.5981 91.1025 47.1713 91.8097 47.1713L105.195 47.1713H118.412C119.119 47.1713 119.692 46.5981 119.692 45.891L119.692 10.0494C119.692 9.52518 119.293 9.09629 118.802 9.09629H117.734L91.4198 9.09619Z",
    fill: "#FFEDE5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.5799 12.6641C94.089 12.6641 93.6895 13.093 93.6895 13.6172L93.6895 49.4589C93.6895 50.166 94.2627 50.7392 94.9698 50.7392L108.355 50.7392H121.572C122.279 50.7392 122.852 50.166 122.852 49.4589L122.852 13.6173C122.852 13.0931 122.453 12.6642 121.962 12.6642H120.894L94.5799 12.6641Z",
    fill: "#FFF4C9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.801 18.8691C101.732 20.141 100.399 20.7095 98.7042 20.8614C98.511 20.8783 98.4077 20.8446 98.3968 21.0697C98.1764 25.4962 100.138 28.0343 102.817 29.8579C102.875 29.8973 102.858 29.8973 102.915 29.8579C105.595 28.0372 107.556 25.4962 107.339 21.0697C107.325 20.8446 107.222 20.8784 107.029 20.8614C105.334 20.7095 104.004 20.141 102.934 18.8691C102.853 18.7734 102.88 18.7734 102.801 18.8691Z",
    fill: "#FF4F00"
  }))), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 98.5859,
    y: 33.5249,
    width: 19.5199,
    height: 1.34705,
    rx: 0.673524,
    fill: "#FFE680"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 111.601,
    y: 28.1367,
    width: 6.50664,
    height: 1.34705,
    rx: 0.673525,
    fill: "#FFE680"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 111.601,
    y: 24.0957,
    width: 6.50664,
    height: 1.34705,
    rx: 0.673525,
    fill: "#FFE680"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 111.601,
    y: 20.0547,
    width: 6.50664,
    height: 1.34705,
    rx: 0.673525,
    fill: "#FFE680"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 98.5859,
    y: 37.5674,
    width: 19.5199,
    height: 1.34705,
    rx: 0.673526,
    fill: "#FFE680"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 98.5889,
    y: 41.606,
    width: 19.5199,
    height: 1.34705,
    rx: 0.673525,
    fill: "#FFE680"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M120.246 46.8096L122.031 48.5984L120.714 49.9154L118.925 48.131L120.246 46.8096Z",
    fill: "#696158"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M112.936 50.3593C118.204 50.3593 122.475 46.0884 122.475 40.82C122.475 35.5516 118.204 31.2808 112.936 31.2808C107.667 31.2808 103.396 35.5516 103.396 40.82C103.396 46.0884 107.667 50.3593 112.936 50.3593Z",
    fill: "#ABADAF"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M125.228 54.3514C124.899 54.3519 124.584 54.2212 124.352 53.9883L121.047 50.6837C120.577 50.1974 120.584 49.4245 121.062 48.9465C121.54 48.4684 122.313 48.4617 122.799 48.9314L126.104 52.236C126.459 52.5904 126.565 53.1234 126.373 53.5864C126.181 54.0494 125.729 54.3513 125.228 54.3514Z",
    fill: "#00CCCC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M120.7 40.7921C120.704 43.0381 119.73 45.1735 118.035 46.6378C115.761 47.1271 113.389 46.558 111.58 45.0891C109.772 43.6203 108.721 41.4091 108.721 39.0728C108.718 37.5412 109.172 36.0439 110.026 34.7745C110.405 34.1971 110.864 33.6775 111.39 33.2314C111.919 33.1136 112.458 33.0545 112.999 33.0552C117.249 33.0639 120.692 36.5228 120.7 40.7921Z",
    fill: "#FFF7D9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.698 40.9792C120.613 45.1938 117.17 48.5842 112.935 48.5842C108.647 48.5842 105.171 45.1079 105.171 40.8197C105.171 36.5315 108.647 33.0552 112.935 33.0552C112.945 33.0552 112.954 33.0552 112.964 33.0552C112.434 33.0572 111.907 33.1162 111.391 33.2314C110.864 33.6775 110.405 34.1971 110.026 34.7745C109.173 36.0439 108.718 37.5412 108.721 39.0728C108.721 41.4091 109.772 43.6203 111.58 45.0891C113.389 46.558 115.761 47.1271 118.035 46.6378C119.683 45.2142 120.649 43.1564 120.698 40.9792Z",
    fill: "#FFF0B3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8420_85373",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 105,
    y: 33,
    width: 16,
    height: 16
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M112.935 48.5842C117.224 48.5842 120.7 45.1079 120.7 40.8197C120.7 36.5315 117.224 33.0552 112.935 33.0552C108.647 33.0552 105.171 36.5315 105.171 40.8197C105.171 45.1079 108.647 48.5842 112.935 48.5842Z",
    fill: "#3B97D3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8420_85373)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103.842,
    y: 32.6118,
    width: 15.5291,
    height: 2.21844,
    rx: 1.10922,
    fill: "#FFE680"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.51,
    y: 37.0498,
    width: 16.8601,
    height: 2.21843,
    rx: 1.10922,
    fill: "#FFE680"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.622,
    y: 41.4858,
    width: 17.7475,
    height: 2.21844,
    rx: 1.10922,
    fill: "#FFE680"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8420_85373",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 105,
    y: 33,
    width: 16,
    height: 16
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.699 40.8197C120.699 45.1079 117.223 48.5842 112.934 48.5842C108.646 48.5842 105.17 45.1079 105.17 40.8197C105.17 36.5315 108.646 33.0552 112.934 33.0552C112.944 33.0552 112.953 33.0552 112.962 33.0552C112.433 33.0571 111.906 33.1162 111.389 33.2314C110.863 33.6775 110.403 34.1971 110.024 34.7745C109.171 36.0439 108.716 37.5412 108.719 39.0728C108.719 41.4091 109.77 43.6203 111.579 45.0891C113.387 46.558 115.759 47.1271 118.033 46.6378C119.729 45.1735 120.702 43.0381 120.699 40.7921C120.699 40.7569 120.698 40.7218 120.698 40.6867C120.699 40.7309 120.699 40.7753 120.699 40.8197Z",
    fill: "#FFF0B3"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8420_85373)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103.84,
    y: 32.6118,
    width: 15.5291,
    height: 2.21844,
    rx: 1.10922,
    fill: "#FFD733"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.509,
    y: 37.0498,
    width: 16.8601,
    height: 2.21843,
    rx: 1.10922,
    fill: "#FFD733"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.621,
    y: 41.4858,
    width: 17.7475,
    height: 2.21844,
    rx: 1.10922,
    fill: "#FFD733"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgMessage3);
export default __webpack_public_path__ + "static/media/imgMessage3.023077bd4193facbfa225a075a6af9cd.svg";
export { ForwardRef as ReactComponent };